module.exports = __webpack_public_path__ + "img/vivaldi_oak_bfusa_list.7e898de8.jpg";